import { useEffect } from "react";
import { useStore } from "../Context.js";
import ImageThemed from "../components/Images/ImageThemed.jsx";
import Navigation from "../components/Navigation/Navigation.jsx";
import loanlogs from "../services/loanlogs.js";

export default function StepSelfieIntro() {
    const { stepForward } = useStore();
    
    function handleSubmit () {
        stepForward();
    };

    useEffect(() => {
        loanlogs.success('/selfie/intro').catch(console.log)
    }, []);
    
    return (
        <main className="page-step page-selfie-intro">
            <Navigation />
            <h1 className="page-header" hidden>
                Firma electrónica
            </h1>
            <div className="page-content">
                <ImageThemed 
                    className="image self-center"
                    src="/selfie-intro.svg" 
                    alt="Ilustracion de una persona tomandose una selfie"
                    width="250"
                />
                <ul className="icon-list">
                    <li>
                        <ImageThemed src="/icon-face.svg" alt="" width="24" />
                        <span>
                            Ubicá tu rostro en el <strong>centro del marco</strong>.
                            Preferiblemente con <strong>fondo liso</strong>.
                        </span>
                    </li>
                    <li>
                        <ImageThemed src="/icon-light.svg" alt="" width="24" />
                        <span>
                            Busca un espacio claro y <strong>bien iluminado</strong>.
                            Evitá los reflejos.
                        </span>
                    </li>
                    <li>
                        <ImageThemed src="/icon-no-glasses.svg" alt="" width="24" />
                        <span>
                            Evitá usar anteojos o accesorios que tapen tu rostro.
                        </span>
                    </li>
                    <li>
                        <ImageThemed src="/icon-background.svg" alt="" width="24" />
                        <span>
                            Usá el <strong>mismo fondo</strong> para las fotos.
                        </span>
                    </li>
                </ul>
            </div>
            <div className="page-actions flex-column">
                <button className="button-primary" onClick={handleSubmit}>Continuar</button>
            </div>
        </main>
    )
}